import React, { useState } from "react";
import Avatar from "antd/lib/avatar/avatar";
import { Card, Spin } from "antd";
import { AppManager } from "../../../manager";
import MainLayout from "../../../layouts/MainLayout/MainLayout";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { Organization } from "../../../models/Organization/Organization";
import AppContent from "../../../containers/AppContent/AppContent";
import Styles from "./AuthorizedOrganizationsPage.scss";
import Logo from "../../../components/Logo/Logo";
import PagePlaceholder from "../../../components/PagePlaceholder/PagePlaceholder";
import placeholderImg from "../../../assets/img/simple_placeholder1.png";

export const SelectOrganizationView: React.FC<{ onSelectOrg: (org: Organization) => void }> = ({ onSelectOrg }) => {
    const userOrgs = useSelector<RootState, Organization[]>((state) => state.orgs.orgs);
    return !userOrgs.length ? (
        <PagePlaceholder
            image={placeholderImg}
            title="No Organizations"
            desc="Looks like your this dealer group has not yet been granted access to any organizations yet"
        />
    ) : (
        <div className={Styles.OrgsViewContainer}>
            <div className={Styles.SelectOrgTitle}>Select Organization</div>
            <div className={Styles.SelectOrgDesc}>You are currently authorized to access the these organizations</div>
            <div className={Styles.OrgListContainer}>
                {userOrgs.map((t) => (
                    <div key={t.id} className={Styles.OrgItemContainer} onClick={() => onSelectOrg(t)}>
                        <Logo imgStyle={{ width: 90 }} />
                        <div className={Styles.Text}>{t.data.attrs.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const AuthorizedOrganizationsPage = () => {
    const [loading, setLoading] = useState(false);
    const handleSetActiveOrg = (org: Organization) => {
        setLoading(true);
        AppManager.org.activateOrganization(org, (err) => {
            setLoading(false);
            if (err) AppManager.alert.error("Error Activating Organiation", `${err}`);
            else AppManager.route.gotoDashboard();
        });
    };

    return (
        <MainLayout>
            <AppContent header="">
                <Card className="match-parent">
                    <Spin spinning={loading} tip="Switching to organization">
                        <SelectOrganizationView onSelectOrg={handleSetActiveOrg} />
                    </Spin>
                </Card>
            </AppContent>
        </MainLayout>
    );
};

export default AuthorizedOrganizationsPage;
